import { defineMessages } from 'react-intl';

const messages = defineMessages({
  myFleetTitle: {
    id: 'fleet.title',
    defaultMessage: 'Fleet Overview',
    description: 'Fleet page title',
  },
  myFleetSubtitle: {
    id: 'fleet.subtitle',
    defaultMessage: 'Choose your machine or implement for additional details',
    description: 'Fleet page title',
  },
  warrantySubtitle: {
    id: 'fleet.warrantySubtitle',
    defaultMessage: 'Choose your machine to see Warranty Information',
    description: 'Fleet page title',
  },
  pspSubtitle: {
    id: 'fleet.pspSubtitle',
    defaultMessage: 'Choose your machine to see Product Support Program (PSP) Information',
    description: 'Fleet page title',
  },
  machineListCount: {
    id: 'task.fleet.taskCount',
    defaultMessage: 'Showing {visible} of {total} machines',
    description: 'Fleet list visible of total machines',
  },
  manageYourFleet: {
    id: 'fleet.manageYourFleet',
    defaultMessage: 'Manage your fleet',
    description: 'Manage your fleet',
  },
  addMachineButton: {
    id: 'fleet.addMachineButton',
    defaultMessage: 'Add machine',
    description: 'Add machine button on fleet page',
  },
  noMachinesFound: {
    id: 'fleet.noMachinesFound.title',
    defaultMessage: 'Get started by adding your first Machine',
    description: 'No Machines found title',
  },
  noMachinesFoundDescription: {
    id: 'fleet.noMachinesFound.description',
    defaultMessage: 'Get started by adding your first Machine',
    description: 'No Machines found description',
  },
  addMachineStep1Title: {
    id: 'fleet.addMachine.step1.title',
    defaultMessage: 'Vehicle identification number (VIN)',
    description: 'add machine step 1 title',
  },
  addMachineStep1Description: {
    id: 'fleet.addMachine.step1.description',
    defaultMessage: 'Identify your machine',
    description: 'add machine step 1 description',
  },
  addMachineStep2Title: {
    id: 'fleet.addMachine.step2.title',
    defaultMessage: 'Check machine details',
    description: 'add machine step 2 title',
  },
  addMachineStep2Description: {
    id: 'fleet.addMachine.step2.description',
    defaultMessage: 'Read your summary and add machine',
    description: 'add machine step 2 description',
  },
  addMachineStep3Title: {
    id: 'fleet.addMachine.step3.title',
    defaultMessage: 'Date and Condition',
    description: 'add machine step 3 title',
  },
  addMachineStep3Description: {
    id: 'fleet.addMachine.step3.description',
    defaultMessage: 'Select date of purchase and condition of the machine',
    description: 'add machine step 3 description',
  },
  addMachineStep3Instruction: {
    id: 'fleet.addMachine.step3.instruction',
    defaultMessage: 'Please indicate the date of purchase and whether you purchased the machine new or used.',
    description: 'add machine step 3 instruction',
  },
  addMachineStep4Title: {
    id: 'fleet.addMachine.step4.title',
    defaultMessage: 'Machine Ownership Verification',
    description: 'add machine step 4 title',
  },
  addMachineStep4Description: {
    id: 'fleet.addMachine.step4.description',
    defaultMessage: 'Please upload documents for verification',
    description: 'add machine step 4 description',
  },
  addMachineStep4Instruction: {
    id: 'fleet.addMachine.step4.instruction',
    defaultMessage: 'Please upload documents to verify your machine',
    description: 'add machine step 4 instruction',
  },
  vinNumberPlaceholder: {
    id: 'fleet.addMachine.step1.vin.placeholder',
    defaultMessage: 'Enter your VIN',
    description: 'add machine step 1 VIN text input placeholder',
  },
  vinNumberInvalidFormat: {
    id: 'fleet.addMachine.step1.vin.invalidFormat',
    defaultMessage: 'Please enter valid format for VIN',
    description: 'add machine step 1 VIN text input invalid format validation',
  },
  vinNumberNotFound: {
    id: 'fleet.addMachine.step1.vin.notFound',
    defaultMessage:
      'We could not find any data for the VIN you are looking for. Either the machine is too old or it\'s a non-AGCO VIN. By pressing "Skip" you can continue to manually add the machine.',
    description: 'VIN number not found validation',
  },
  vinNumberAlreadyInAccount: {
    id: 'fleet.addMachine.step1.vin.alreadyInAccount',
    defaultMessage:
      'The machine with the VIN {vin} is already added to your fleet. Please try another AGCO VIN number.',
    description: 'VIN number already in account',
  },
  vinServiceError: {
    id: 'fleet.addMachine.step1.vin.serviceError',
    defaultMessage: 'We are unable to search for your VIN at the moment. Please try again later.',
    description: 'VIN number service error',
  },
  machineIsImplementError: {
    id: 'fleet.addMachine.step1.vin.machineIsImplement',
    defaultMessage: 'This VIN belongs to an implement. Please enter a VIN number for an AGCO machine.',
    description: 'VIN number belongs to an implement error',
  },
  nonAgcoIsNotSupported: {
    id: 'fleet.addMachine.step1.cin.nonAgcoNotSupported',
    defaultMessage: 'Non-AGCO machines are not supported. Please enter a VIN number for an AGCO machine.',
    description: 'VIN non-agco machines not supported',
  },
  productTypeTitle: {
    id: 'fleet.addMachine.step2.productType.title',
    defaultMessage: 'Product type',
    description: 'add machine step 2 product type title',
  },
  productTypeDescription: {
    id: 'fleet.addMachine.step2.productType.description',
    defaultMessage: 'Your equipment type',
    description: 'add machine step 2 product type description',
  },
  productTypeInstruction: {
    id: 'fleet.addMachine.productType.instruction',
    defaultMessage: 'Please select a product type.',
    description: 'Instruction for selecting a product type in machine addition process',
  },
  machine: {
    id: 'fleet.machine.productType.machine',
    defaultMessage: 'Machine',
    description: 'Label for the "Machine" product type in machine addition process',
  },
  implement: {
    id: 'fleet.machine.productType.implement',
    defaultMessage: 'Implement',
    description: 'Label for the "Implement" product type in machine addition process',
  },
  machineCategory: {
    id: 'fleet.machine.category',
    defaultMessage: 'Category',
    description: 'Machine category',
  },
  machineSubCategory: {
    id: 'fleet.machine.subCategory',
    defaultMessage: 'Sub-Category',
    description: 'Machine Sub-category',
  },
  machineInformation: {
    id: 'fleet.machine.information.title',
    defaultMessage: 'Machine information',
    description: 'Machine information',
  },
  machineDetails: {
    id: 'fleet.machinedetails',
    defaultMessage: 'Machine details',
    description: 'Machine details',
  },
  brand: {
    id: 'fleet.machine.brand',
    defaultMessage: 'Brand',
    description: 'brand',
  },
  model: {
    id: 'fleet.machine.model',
    defaultMessage: 'Model',
    description: 'model',
  },
  modelVariant: {
    id: 'fleet.machine.modelVariant',
    defaultMessage: 'Model variant',
    description: 'model variant',
  },
  series: {
    id: 'fleet.machine.series',
    defaultMessage: 'Series',
    description: 'series',
  },
  variant: {
    id: 'fleet.machine.variant',
    defaultMessage: 'Variant',
    description: 'variant',
  },
  yearOfManufacturing: {
    id: 'fleet.machine.yearOfManufacturing',
    defaultMessage: 'Year of Manufacture',
    description: 'year of manufacturing',
  },
  startDate: {
    id: 'fleet.machine.startDate',
    defaultMessage: 'Date of purchase',
    description: '',
  },
  conditionLabel: {
    id: 'fleet.machine.condition.label',
    defaultMessage: 'Condition',
    description: 'machine condition, label',
  },
  conditionNew: {
    id: 'fleet.machine.condition.new',
    defaultMessage: 'New machine',
    description: 'machine condition, new',
  },
  conditionUsed: {
    id: 'fleet.machine.condition.used',
    defaultMessage: 'Used machine',
    description: 'machine condition, used',
  },
  uploadingDocuments: {
    id: 'fleet.addMachine.step4.uploadingDocuments.title',
    defaultMessage: 'Uploading documents',
    description: 'add machine, step 4, updloading documents title',
  },
  uploadingDocumentsDescription: {
    id: 'fleet.addMachine.step4.uploadingDocuments.description',
    defaultMessage:
      "In order to protect our customer's personal data, Please provide ownership documents such as Purchase contract, Registration certificate part 1, Registration certificate part 2. You can upload up to 3 files.",
    description: 'add machine, step 4, updloading documents description',
  },
  deleteMachineModalConfirmation: {
    id: 'fleet.machine.deleteMachineModal.confirmation',
    defaultMessage:
      'Are you sure you want to delete this machine? This action cannot be undone.{lineBreak}You will no longer have access to view or edit the machine.',
    description: 'delete machine modal confirmation',
  },
  emptyMachineNameModal: {
    id: 'fleet.machine.emptyMachineNameModal',
    defaultMessage: 'If you leave the name empty, it will be automatically changed to',
    description: 'empty machine name modal',
  },
  details: {
    id: 'fleet.machine.details',
    defaultMessage: 'Details',
    description: 'machine details',
  },
  warrantyTabTitle: {
    id: 'fleet.machine.warranty',
    defaultMessage: 'Warranty',
    description: 'machine warranty tab title',
  },
  manualsTabTitle: {
    id: 'fleet.machine.manuals',
    defaultMessage: 'Manuals',
    description: 'machine manuals tab title',
  },
  pspTabTitle: {
    id: 'fleet.machine.psp',
    defaultMessage: 'Product Support Programs (PSP)',
    description: 'machine product support program tab title',
  },
  ownershipStatus: {
    id: 'fleet.machine.ownerShipStatus',
    defaultMessage: 'Ownership status',
    description: 'machine ownership status',
  },
  vehicleIdNumber: {
    id: 'fleet.machine.vehicleIdNumber',
    defaultMessage: 'VIN',
    description: 'machine vehicle ID number',
  },
  brandStepInstruction: {
    id: 'fleet.addMachine.brand.instruction',
    defaultMessage: 'Please select the brand',
    description: 'Instruction for the brand selection step in machine addition process',
  },
  vinStepInstruction: {
    id: 'fleet.addMachine.vin.instruction',
    defaultMessage: 'Identify your machine',
    description: 'Instruction for identifying machine using VIN in machine addition process',
  },
  vinStepAddVin: {
    id: 'fleet.addMachine.vin.addVin',
    defaultMessage: 'Add VIN number',
    description: 'Action text for adding VIN number in machine addition process',
  },
  categoryStepInstruction: {
    id: 'fleet.addMachine.category.instruction',
    defaultMessage: 'Please select Category and Sub-category',
    description: 'Instruction for category and sub-category selection in machine addition process',
  },
  machineInfoStepInstruction: {
    id: 'fleet.addMachine.machineInfo.instruction',
    defaultMessage: 'Please select model and year of manufacture',
    description: 'Instruction for selecting model and year of manufacturing in machine addition process',
  },
  dateStepTitle: {
    id: 'fleet.addMachine.date.title',
    defaultMessage: 'Date of purchase',
    description: 'Title for date of purchase step in machine addition process',
  },
  dateStepInstruction: {
    id: 'fleet.addMachine.date.instruction',
    defaultMessage: 'Please select start date and condition',
    description: 'Instruction for selecting start date and condition in machine addition process',
  },
  dateStepDescription: {
    id: 'fleet.addMachine.date.description',
    defaultMessage: 'Please select start date of ownership and condition at the time of purchase',
    description: 'Detailed instruction for selecting start date of ownership and condition in machine addition process',
  },
  proofOfOwnership: {
    id: 'fleet.addMachine.proofOfOwnership',
    defaultMessage: 'Proof of ownership',
    description: 'Proof of ownership',
  },
  dateStepSelectCondition: {
    id: 'fleet.addMachine.date.selectCondition',
    defaultMessage: 'Please select condition.',
    description: 'Prompt for selecting condition of machine in machine addition process',
  },
  dateStepOwnershipStartDate: {
    id: 'fleet.addMachine.date.ownershipStartDate',
    defaultMessage: 'Ownership start date',
    description: 'Label for ownership start date field in machine addition process',
  },
  dateStartDate: {
    id: 'fleet.addMachine.date.startDate',
    defaultMessage: 'Start date',
    description: 'Label for start date field in machine addition process',
  },
  addMachineStepInstruction: {
    id: 'fleet.addMachine.step.instruction',
    defaultMessage: 'Read summary and add machine',
    description: 'Final instruction to read summary and add machine in machine addition process',
  },
  summaryStepTitle: {
    id: 'fleet.addMachine.summary.title',
    defaultMessage: 'Add Machine',
    description: 'Add Machine title',
  },
  combinedDetailsTitle: {
    id: 'fleet.addMachine.combinedDetails.title',
    defaultMessage: 'Brand, Category, Machine information, Date and condition',
    description: 'Title for combined details step in machine addition process',
  },
  statusVerified: {
    id: 'fleet.status.verified',
    defaultMessage: 'Verified',
    description: 'Fleet status verified',
  },
  statusUnverified: {
    id: 'fleet.status.unverified',
    defaultMessage: 'Unverified',
    description: 'Fleet status unverified',
  },
  statusRejected: {
    id: 'fleet.status.rejected',
    defaultMessage: 'Rejected',
    description: 'Fleet status rejected',
  },
  statusPending: {
    id: 'fleet.status.pending',
    defaultMessage: 'Pending',
    description: 'Fleet status pending',
  },
  statusReadyToSubmit: {
    id: 'fleet.status.readyToSubmit',
    defaultMessage: 'Ready to Submit',
    description: 'Fleet status ready to submit',
  },
  newMachineAdded: {
    id: 'fleet.addMachine.newMachineAdded',
    defaultMessage: 'New machine added',
    description: 'Add machine success, new machine added, notification title',
  },
  machineAddedSuccessfully: {
    id: 'fleet.addMachine.machineAddedSuccessfully',
    defaultMessage: '{brand} {model} was added successfully. ',
    description: 'Add machine success, notification description',
  },
  machineAddedFailedNotiTitle: {
    id: 'fleet.addMachine.machineAddedFailedNotiTitle',
    defaultMessage: 'Error adding machine',
    description: 'Add machine failed, notification title',
  },
  machineAddedFailedNotiDescription: {
    id: 'fleet.addMachine.machineAddedFailedNotiDescription',
    defaultMessage:
      'Adding {brand} {model} failed. Please try again or click "Cancel" {lineBreak} If the problem persists, please contact customer support',
    description: 'Add machine failed, notification description',
  },
  ownershipInProgress: {
    id: 'fleet.addMachine.ownershipInProgress',
    defaultMessage: 'Machine verification is ongoing',
    description: 'Add machine success, verification is ongoing, notification description',
  },
  enterVin: {
    id: 'fleet.machineDetails.enterVin',
    defaultMessage: 'Enter VIN',
    description: 'Add VIN modal title',
  },
  addVinDescription: {
    id: 'fleet.machineDetails.addVinDescription',
    defaultMessage: 'A VIN is required to access Information connected to your specific machine',
    description: 'Add VIN modal descripion',
  },
  vinInputLabel: {
    id: 'fleet.machineDetails.vinInputLabel',
    defaultMessage: 'Please enter a VIN number',
    description: 'VIN input label',
  },
  addVinError: {
    id: 'fleet.machineDetails.addVinError',
    defaultMessage: 'This VIN is not correct. Please check the VIN Number or contact our support team',
    description: 'Add VIN error message',
  },
  verifyMachineDetailsInfoText: {
    id: 'fleet.machineDetails.verifyMachineDetailsInfoText',
    defaultMessage:
      'Your Machine Details List states "{machineDetailsChange}". Please confirm if you want to continue with this update',
    description: 'Verify machine details info text',
  },
  verifyMachineWarningText: {
    id: 'fleet.machineDetails.verifyMachineWarningText',
    defaultMessage: 'You are about to update this machine across all your fleets.{lineBreak}Would you like to proceed?',
    description: 'Verify machine warning text',
  },
  verifyMachinePageTitle: {
    id: 'fleet.machineDetails.verifyMachinePageTitle',
    defaultMessage: 'Check machine details to add VIN',
    description: 'Verify machine page title',
  },
  verifyMachinePageSubtitle: {
    id: 'fleet.machineDetails.verifyMachinePageSubtitle',
    defaultMessage: 'Please review and confirm that the data shown are correct',
    description: 'Verify machine page subtitle',
  },
  searchBarPlaceholder: {
    id: 'fleet.searchBar.placeholder',
    defaultMessage: 'Search by Name, Brand or Model',
    description: 'Search bar placeholder',
  },
  noMachinesMatchSearchCriteria: {
    id: 'fleet.noMachinesMatchSearchCriteria',
    defaultMessage: "We're sorry, but no machines match your search criteria.",
    description: 'No machines match search criteria',
  },

  deleteImageConfirmation: {
    id: 'fleet.deleteImageConfirmation',
    defaultMessage: 'Are you sure you want to delete this image?',
    description: 'Delete image confirmation',
  },
  deleteImageConfirmationDescription: {
    id: 'fleet.deleteImageConfirmationDescription',
    defaultMessage: "This item will be deleted immediately. You can't undo this action.",
    description: 'Delete image confirmation description',
  },
  machineImageUpload: {
    id: 'fleet.machineImageUpload',
    defaultMessage: 'Machine image upload',
    description: 'Machine image upload',
  },
  selectImageToUpload: {
    id: 'fleet.selectImageToUpload',
    defaultMessage: 'Please select image to upload',
    description: 'Please select image to upload',
  },
  browseImage: {
    id: 'fleet.browseImage',
    defaultMessage: 'Browse image',
    description: 'Browse image',
  },
  leaveAddMachineModalTitle: {
    id: 'fleet.leaveAddMachineModalTitle',
    defaultMessage: 'Business changed successfully',
    description: 'Leave add machine modal title',
  },
  leaveAddMachineModalDescription: {
    id: 'fleet.leaveAddMachineModalDescription',
    defaultMessage: 'To stay in Add Machine click on Cancel, to leave click on Leave',
    description: 'Leave add machine modal description',
  },
  notes: {
    id: 'fleet.notes',
    defaultMessage: 'Notes',
    description: 'Notes',
  },
  yourNotes: {
    id: 'fleet.yourNotes',
    defaultMessage: 'Your Notes',
    description: 'Your Notes',
  },
  createNewNote: {
    id: 'fleet.createNewNote',
    defaultMessage: 'Create new note',
    description: 'Create new note',
  },
  editNote: {
    id: 'fleet.editNote',
    defaultMessage: 'Edit Note',
    description: 'Edit Note',
  },
  descriptionMaxLength: {
    id: 'fleet.descriptionMaxLength',
    defaultMessage: 'Description reached the maximum allowed length of {maxLength} characters',
    description: 'Description reached the maximum allowed length of {maxLength} characters',
  },
  noNotesYet: {
    id: 'fleet.noNotesYet',
    defaultMessage: 'You have no notes yet.',
    description: 'Message shown when user has no notes',
  },
  createFirstNote: {
    id: 'fleet.createFirstNote',
    defaultMessage: 'Create first note',
    description: 'Button text to create first note',
  },
  hideNote: {
    id: 'fleet.hideNote',
    defaultMessage: 'Hide note',
    description: 'Button text to hide note in mobile view',
  },
  showNote: {
    id: 'fleet.showNote',
    defaultMessage: 'Show note',
    description: 'Button text to show note in mobile view',
  },
  noteTitle: {
    id: 'fleet.note.title',
    defaultMessage: 'Note title',
    description: 'Label for note title',
  },
  noteCreator: {
    id: 'fleet.note.creator',
    defaultMessage: 'Creator',
    description: 'Label for note creator',
  },
  deleteNoteModalConfirmation: {
    id: 'fleet.deleteNoteModalConfirmation',
    defaultMessage: 'Are you sure you want to delete note {title} from the list?',
    description: 'Confirmation message when deleting a note',
  },
  deleteNote: {
    id: 'fleet.deleteNote',
    defaultMessage: 'Delete note',
    description: 'Button text for deleting a note',
  },
  titleMaxLength: {
    id: 'fleet.titleMaxLength',
    defaultMessage: 'Title reached the maximum allowed length of {maxLength} characters',
    description: 'Title reached the maximum allowed length of {maxLength} characters',
  },
  titleRequired: {
    id: 'fleet.titleRequired',
    defaultMessage: 'Title is required',
    description: 'Error message when title is required',
  },
  showActivePsps: {
    id: 'fleet.showActivePsps',
    defaultMessage: 'Show only active PSPs',
    description: 'Show active PSPs checkbox label',
  },
  machineImageUploadFileTypeText: {
    id: 'fleet.machineImageUploadFileTypeText',
    defaultMessage: 'JPG, JPEG, JFIF, PNG (Max. {maxSize}MB)',
    description: 'Machine image upload file type text',
  },
  configurationSectionTitle: {
    id: 'fleet.configurationSectionTitle',
    defaultMessage: 'Configuration',
    description: 'Configuration section title',
  },
  selectAtLeastOneValueWarning: {
    id: 'fleet.selectAtLeastOneValueWarning',
    defaultMessage: 'Please select at least one value.',
    description: 'Warning message when no value is selected',
  },
  expertLinkTabTitle: {
    id: 'fleet.machine.expertLink',
    defaultMessage: 'ExpertLink',
    description: 'machine ExpertLink tab title',
  },
});

export default messages;
